import React, { useEffect } from "react";
import { useSelector } from "react-redux";

export default function SpousePropdisplay() {
    const ownerInfo = useSelector((state) => state?.addressdetail?.info1);
; 
  return (
    <>
    <div className="d-flex px-3 row row-cols-xl-3 row-cols-lg-3 row-cols-md-2 row-cols-sm-1 row-cols-1">
      <div className="py-2 px-2 text-nowrap col-xl-4 col-lg-4 col-md-6 col-sm-6 col-6">
        <div className="indivtexthead">FULL NAME</div>
        <div className="indivtext">{ownerInfo?.Spouse?.title}. {' '}{ownerInfo?.Spouse?.SpouseName}</div>
      </div>
      <div className="py-2 px-2 text-nowrap col-xl-4 col-lg-4 col-md-6 col-sm-6 col-6">
        <div className="indivtexthead">DATE OF BIRTH</div>
        <div className="indivtext">{ownerInfo?.Spouse?.dateofbirth}</div>
      </div>
      <div className="py-2 px-2 text-nowrap col-xl-4 col-lg-4 col-md-6 col-sm-6 col-6">
        <div className="indivtexthead">Height</div>
        <div className="indivtext">{ownerInfo?.Spouse?.SpouseHeight}{' '}{ownerInfo?.Spouse?.SpouseInches}</div>
      </div>
      <div className="py-2 px-2 text-nowrap col-xl-4 col-lg-4 col-md-6 col-sm-6 col-6">
        <div className="indivtexthead">Weight</div>
        <div className="indivtext">{ownerInfo?.Spouse?.SpouseWeight}{' '}kg</div>
      </div>
      <div className="py-2 px-2 text-nowrap col-xl-4 col-lg-4 col-md-6 col-sm-6 col-6">
        <div className="indivtexthead">Blood Group</div>
        <div className="indivtext">{ownerInfo?.Spouse?.SpouseBloodGroup}</div>
      </div>
    </div>
    </>
  );
}
